import * as z from 'zod';

export const mbmProjectFormSchema = z.object({
  ProjectId: z.string().trim().min(1, { message: 'MBM_PROJECT_ID_REQUIRED' }),
  ProjectName: z.string().trim().min(1, { message: 'MBM_PROJECT_NAME_REQUIRED' }),
  CustomerId: z.string().trim().min(1, { message: 'MBM_CUSTOMER_ID_REQUIRED' }),
  CustomerName: z.string().trim().min(1, { message: 'MBM_CUSTOMER_NAME_REQUIRED' }),
  Status: z.string().min(1, { message: 'MBM_PROJECT_STATUS_REQUIRED' }),
});

export type MbmProjectFormValues = z.infer<typeof mbmProjectFormSchema>;
